import { render, staticRenderFns } from "./CategoriaList.vue?vue&type=template&id=87eb052a"
import script from "./CategoriaList.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriaList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports